<div class="action-btn">
  <div *ngFor="let button of actionsList; let i = index; trackBy: identifyActions">
    <ces-button
      *ngIf="i < 2 || (actionsList.length == 3 && i < 3)"
      label=""
      (onClick)="onItemClick(button)"
      [icon]="button.icon"
      size="large"
      [ghost]="true"
      ghostType="secondary"
      [title]="button.actionName"
    >
    </ces-button>

    <div
      *ngIf="actionsList.length > 3 && i === 2"
      kendoTooltip
      class="top"
    >
      <kendo-dropdownbutton
        class="action-dropdown-btn"
        [data]="getExtraButtons(actionsList)"
        (itemClick)="onItemClick($event)"
        [popupSettings]="{ popupClass: 'action-dropdown-list', animate: false }"
      >
        <i class="icon icon-ellipses"></i>
        <ng-template
          kendoDropDownButtonItemTemplate
          let-dataItem
        >
          <div class="action-icon-text">
            <i class="{{ dataItem.icon }}"></i>
            <span>{{ dataItem.actionName }}</span>
          </div>
        </ng-template>
      </kendo-dropdownbutton>
    </div>
  </div>
</div>
